module.exports = __webpack_public_path__ + "img/Voice of the indivdual.5baabe64.png";